import { useEffect } from 'react';
import { useCashSession } from '../../hooks/cash/useCashSession';
import CashSessionInfoView from './CashSessionInfoView';

const CashSessionInfoCard = () => {

  const { activeSession, getActiveSession } = useCashSession();

  useEffect(() => {
    if (activeSession) {
      getActiveSession();
    }
  }, []);

  return (
    <CashSessionInfoView data={activeSession} />
  );
};

export default CashSessionInfoCard;